// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"27":"941cd19e","33":"7258e6d1","224":"fd739e1d","353":"785b40a3","367":"80879aec","535":"916b8a67","674":"7e77f63a","972":"ba965cb3"}[chunkId] + ".css";
};